import { Injectable, Injector } from '@angular/core';
import { DatasourceTableGitFactoryService } from '@y42/datasource';
import { IntegrationTableGitService } from './integration-table-git.service';

@Injectable({ providedIn: 'root' })
export class IntegrationTableGitFactoryService extends DatasourceTableGitFactoryService<IntegrationTableGitService> {
  constructor(injector: Injector) {
    super({
      injector,
      gitService: IntegrationTableGitService,
    });
  }
}
